const conveniosPaciente = [
  {
    id: 1,
    label: '3) Convênio da paciente',
    name: 'convenio_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Operadoras de saúde',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Particular',
        value: '2',
      },
      {
        id: 3,
        descricao: 'SUS',
        value: '3',
      },
    ],
  },
];

const comorbidades = [
  {
    id: 1,
    label:
      'a) Histórico de Acidente Vascular Cerebral (AVC) ou Ataque Isquêmico Transitório (AIT)',
    name: 'avc_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: 'b) Histórico de Infarto Agudo do Miocárdio (IAM)',
    name: 'iam_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: 'c) Diabetes Mellitus',
    name: 'dm_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 4,
    label: `d) Doença Autoimune em uso atual de imunomoduladores`,
    name: 'autoimune_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 5,
    label: `e) Tabagismo atual (até imediatamente antes da internação atual)`,
    name: 'tabagismo_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const dadosDaDoenca = [
  {
    id: 1,
    label: '8) Paciente com câncer de mama metastático',
    name: 'metastase_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const inflamatorio = [
  {
    id: 1,
    label: '9) Paciente com câncer de mama inflamatório',
    name: 'ca_inflamatorio_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];


const estadiamentoClinico = [
  {
    id: 1,
    label: '12) Estadiamento clínico axilar pré-operatório positivo',
    name: 'estad_clinico_mama',
    opcoes: [
      {
        id: 1,
        descricao:
          'Sim - Paciente com exame clínico com presença de gânglios fusionados axilares e/ou com punção aspirativa por agulha fina positiva do linfonodo axilar',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];



const tratamento = [
  {
    id: 1,
    label: '15) Procedimento cirúrgico realizado',
    name: 'cirurgia_tipo_mama',
    opcoes: [
      {
        id: 1,
        descricao:
          'Cirurgia conservadora de mama (Tumorectomia / Lumpectomia / Quadrantectomia / Setorectomia / Segmentectomia / Mastectomia parcial)',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Mastectomia total',
        value: '2',
      },
    ],
  },
]

const pesquisaLinfonodo = [
  {
    id: 1,
    label:
      '16) Realizada pesquisa de linfonodo sentinela durante a cirurgia de mama',
    name: 'sentinela_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
]

const reconstrucaoMamaria = [
  {
    id: 1,
    label: '17) Paciente recebeu reconstrução mamária imediata',
    name: 'reconstrucao_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  }
]

const naoRealizacaoMama = [
  {
    id: 1,
    label: '18) Motivo da não-realização da reconstrução mamária imediata',
    name: 'nao_realizacao_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Recusa documentada da paciente a receber a reconstrução',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Contraindicação clínica documentada',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Sem registro do motivo',
        value: '3',
      },
    ],
  },
];

const dadosDaSaida = [
  {
    id: 1,
    label: '21) Paciente teve diagnóstico de COVID-19 durante a internação',
    name: 'covid_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao: 'Não testado',
        value: '2',
      },
    ],
  },
  {
    id: 2,
    label: '22) Motivo da saída hospitalar',
    name: 'saida_motivo_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Alta médica',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Óbito',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Evasão',
        value: '3',
      },
      {
        id: 4,
        descricao: 'Transferência',
        value: '4',
      },
    ],
  },
];

const laudoBiopsia = [
  {
    id: 1,
    label: 'a) Número de focos com todas as informações a seguir:',
    name: 'focos_biopsia_mama',
    itens: [
      {
        id: 1,
        descricao: '- tamanho da maior lesão',
      },
      {
        id: 2,
        descricao: '- localização',
      },
      {
        id: 3,
        descricao:
          '- diâmetro máximo do tumor e do maior foco em caso de lesão multicêntrica',
      },
    ],
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label:
      'b) Identificação/análise de margens incluindo todas as informações a seguir:',
    name: 'margens_bipsia_mama',
    itens: [
      {
        id: 1,
        descricao: '- localização',
      },
      {
        id: 2,
        descricao: '- distância da margem',
      },
      {
        id: 3,
        descricao: '- envolvimento ou não de margens',
      },
    ],
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: 'c) Avaliação da presença ou ausência da invasão linfovascular',
    name: 'invasao_linfo_biopsia_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 4,
    label: 'd) Avaliação da expressão de PR e ER, HER2 e Ki67',
    name: 'expressao_biopsia_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const laudoCirurgia = [
  {
    id: 1,
    label: 'a) Descrição do número de focos contendo todos os itens a seguir:',
    name: 'focos_cirurgia_mama',
    itens: [
      {
        id: 1,
        descricao: '- tamanho da maior lesão',
      },
      {
        id: 2,
        descricao: '- localização',
      },
      {
        id: 3,
        descricao: '- diâmetro máximo do tumor (pT)',
      },
    ],
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: 'b) Descrição de todos os seguintes itens:',
    name: 'linfonodos_cirurgia_mama',
    itens: [
      {
        id: 1,
        descricao: '- número total de linfonodos removidos',
      },
      {
        id: 2,
        descricao:
          '- número de linfonodos positivos para câncer com células malignas',
      },
      {
        id: 3,
        descricao: '- presença ou ausência de extravasamento capsular',
      },
      {
        id: 4,
        descricao: '- extensão das metástases linfonodais',
      },
      {
        id: 4,
        descricao:
          '- células tumorais isoladas, micrometástases (de 0,2 a 2 nm) e macrometástases (classificação pN)',
      },
    ],
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: 'c) Tipo e grau histológico do tumor',
    name: 'grau_tumor_mama',

    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 4,
    label:
      'd) Identificação/análise de margens incluindo todos os itens a seguir:',
    name: 'margens_cirurgia_mama',
    itens: [
      {
        id: 1,
        descricao: '- localização',
      },
      {
        id: 2,
        descricao: '- distância da margem',
      },
      {
        id: 3,
        descricao: '- envolvimento ou não de margens',
      },
    ],
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 5,
    label: 'e) Avaliação da presença ou ausência de invasão linfovascular',
    name: 'invasao_linfo_cirurgia_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 6,
    label: 'f) Avaliação da expressão de PR e ER, HER2 e Ki67',
    name: 'expressao_cirurgia_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 7,
    label: '20) Estadiamento TNM pós-operatório registrado em prontuário',
    name: 'tnm_pos_mama',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

export {
  conveniosPaciente,
  comorbidades,
  dadosDaDoenca,
  inflamatorio,
  pesquisaLinfonodo,
  reconstrucaoMamaria,
  tratamento,
  naoRealizacaoMama,
  dadosDaSaida,
  laudoBiopsia,
  laudoCirurgia,
  estadiamentoClinico,
};
